var exports = {
  "x6": "AutocompleteItem.module__button___SU93Qk",
  "kL": "AutocompleteItem.module__container___SU93Qk",
  "wH": "AutocompleteItem.module__selected___SU93Qk",
  "Qs": "AutocompleteItem.module__content___SU93Qk",
  "Kk": "AutocompleteItem.module__icon___SU93Qk",
  "Bm": "AutocompleteItem.module__nameWrapper___SU93Qk",
  "UU": "AutocompleteItem.module__name___SU93Qk",
  "h_": "AutocompleteItem.module__description___SU93Qk",
};

module.exports = exports;
